<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <h2 class="text-white mt-3">Страница не найдена 🤷‍♂️</h2>
              <h3 class="text-white mt-3">Ошибка 404</h3>
              <div class="text-white">
                Упс! У нас нет такой страницы!
                <br />
                Перейдите <router-link to="/">на главную страницу</router-link>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Card,
  Checkbox,
  Button,
  InfoSection,
} from "src/components/UIComponents";
// import AppNavbar from './../Dashboard/Views/Pages/Layout/AppNavbar'
import AppFooter from "./../Dashboard/Layout/ContentFooter";

export default {
  components: {
    Card,
    AppFooter,
    InfoSection,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style scoped>
body {
  /* background: url(/assets/actid/junk-mail.jpg); */
}
.full-page-background {
  background: url(/assets/actid/junk-mail.jpg);
  background-repeat: repeat !important;
  background-size: 200px !important;
}
.container a {
  color: white;
  font-weight: bold;
  text-decoration: underline;
}
</style>
